import { render, staticRenderFns } from "./BuildSet.vue?vue&type=template&id=57f70319&"
import script from "./BuildSet.vue?vue&type=script&lang=js&"
export * from "./BuildSet.vue?vue&type=script&lang=js&"
import style0 from "./BuildSet.vue?vue&type=style&index=0&id=57f70319&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports